import { Button, Input, Stack, Typography } from "@mui/material";
import React, { memo, useCallback, useMemo, useRef } from "react";
import { addLeonardoResource } from "../request/add-leonardo-resource";
import { FetchStatus } from "../request/model/fetch-status";
export const AddLeonardoResourceLayout = memo(() => {
    const inputRef = useRef(null);
    const [status, setStatus] = React.useState(FetchStatus.Idle);
    const handleAddResource = useCallback(() => {
        var _a;
        if (!inputRef.current) {
            return;
        }
        setStatus(FetchStatus.Fetching);
        addLeonardoResource(((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.value) || "")
            .then(() => {
            setStatus(FetchStatus.Success);
        })
            .catch(() => {
            setStatus(FetchStatus.Error);
        });
    }, []);
    const statusLayout = useMemo(() => {
        switch (status) {
            case FetchStatus.Idle:
                return null;
            case FetchStatus.Fetching:
                return React.createElement(Typography, { color: "primary" }, "Loading");
            case FetchStatus.Error:
                return React.createElement(Typography, { color: "error" }, "Error");
            case FetchStatus.Success:
                return React.createElement(Typography, { color: "success" }, "Succeed");
        }
    }, [status]);
    return (React.createElement(Stack, { spacing: 2, direction: "column" },
        React.createElement(Input, { placeholder: "Enter Leonardo English URL", inputRef: inputRef }),
        React.createElement(Button, { variant: "contained", color: "primary", onClick: handleAddResource, sx: { textTransform: "none" } }, "Add Leonardo Resource"),
        statusLayout));
});
AddLeonardoResourceLayout.displayName = "AddLeonardoResourceLayout";
